import { useState, useEffect } from 'react';
import { CragData } from '../utils/navigationUtils';

export function useCrags() {
  const [crags, setCrags] = useState<CragData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadCrags = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch('/data/crags.json');
        if (!response.ok) {
          throw new Error(`Failed to load crags: ${response.statusText}`);
        }

        const cragsData: CragData[] = await response.json();
        setCrags(cragsData);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load crags data');
      } finally {
        setLoading(false);
      }
    };

    loadCrags();
  }, []);

  return { crags, loading, error };
}
